/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 1/7/21.
 */

import config from "@/config";
import axios from "axios";
import store from "@/store";
import * as _ from "lodash";

export default {
	get(station_id) {
		return axios.get(`${config.ZETTA_URL}/station/${station_id}`, {
			headers: {
				"Authorization": store.getters.getAccessToken(),
				"Z-Cloud-Org-Id": store.getters.getOrgID()
			}
		});
	},

	getUserStations(params) {
		params.search = `playout_enabled:true${params.search ? ` AND ${params.search}` : ""}`;
		return axios.get(
			`${config.PORTAL_URL}/api/v5/accounts/${store.getters.getOrgID()}/stations/search`,
			{
				params: _.extend(
					{
						limit: 20,
						offset: 0,
						order: "name",
						direction: "asc"
					},
					params
				),
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	getUserFavoriteStations() {
		return axios.get(
			`${config.PORTAL_URL}/api/v5/users/me/favorites/stations`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	getStudioSettings(studio_id) {
		return axios.get(
			`${config.PORTAL_URL}/api/v5/accounts/${store.getters.getOrgID()}/studio_settings/${studio_id}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	searchStudioSettings(params) {
		return axios.get(
			`${config.PORTAL_URL}/api/v5/accounts/${store.getters.getOrgID()}/studio_settings/search`,
			{
				params: _.extend(
					{
						limit: 20,
						offset: 0,
						order: "name",
						direction: "asc"
					},
					params
				),
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	postStudioSettings(payload) {
		return axios.post(
			`${config.PORTAL_URL}/api/v5/accounts/${store.getters.getOrgID()}/studio_settings`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	putStudioSettings(payload) {
		return axios.put(
			`${config.PORTAL_URL}/api/v5/accounts/${store.getters.getOrgID()}/studio_settings/${payload.reference}`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	postHeartbeat(payload) {
		return axios.post(
			`${config.PORTAL_URL}/api/v5/stations/${store.getters.liveModeSelectedStationID()}/live_console/heartbeat`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	getTrafficLog(stationEnterpriseID, startTime, breakDuration) {
		const url = `${config.PORTAL_PROXY_URL}/api/v1/lapi/stations/stationId/${stationEnterpriseID}/breakStartTime/${startTime}/breakDuration/${breakDuration}`;
		return axios.get(url, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		})
	},

	getStationsByOrgID() {
		return axios.get(
			`${config.ZETTA_URL}/station/byorganization/${store.getters.getOrgID()}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		)
	},

	getStationsBySyndicationType(type) {
		const query = `{
									stations(
										filter: {
											OrganizationID: { EQ: "${store.getters.getOrgID()}" } 
											SyndicationType: {EQ: ${type} }
										}
									)
									{ 
										StationName, StationID
									}
								}`.replace(/([\t\n])+/g, "");	// Remove tab and newline characters for logging reasons in the console

		return axios.post(
			`${config.ZETTA_URL}/station/graphql`,
			{query: query},
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		);
	},

	updateStation({stationID, payload}) {
		return axios.patch(
			`${config.ZETTA_URL}/station/${stationID}`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		);
	},
}
